
define('ldsh!common/templates/message', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div id="message-view" class="container">\n\n    <div class="subnav content" style="display: block;">\n      <h1>\n        <span class="icon icon-warning-sign"></span>\n        <span class="i18n" data-i18n="' +
((__t = (title)) == null ? '' : __t) +
'"></span>\n      </h1>\n    </div>\n    <!-- target content -->\n    <div class="content clearfix" style="display: block;">\n\n        <div class="row-fluid js-content">\n            <div class="container">\n              <p class="i18n" data-i18n="' +
((__t = (content)) == null ? '' : __t) +
'"></p>\n            </div>\n        </div>\n\n    </div>\n    <!-- footer -->\n    <footer style="">\n        <p>\n            (&copy;) ' +
__e(new Date().getFullYear()) +
' Marketing Manager Servicios de Marketing, S.L. -\n            <span data-i18n="FOOTER.ALL_RIGHT" class="i18n"></span>\n        </p>\n        <!-- SmartAdserver Tracking Begin -->\n        <!-- MDirector Cliente -->\n        <!-- Tracking with script -->\n\n        <noscript>&lt;iframe src="//ww264.smartadserver.com/track/ift2.asp?183427;16564;123456;0;[transactionid];[reference]" width=1 height=1 iframeborder=0&gt; &lt;/iframe&gt;</noscript>\n        <!-- SmartAdserver Tracking End -->\n    </footer>\n    <!-- footer ends -->\n</div>\n';

}
return __p
};});

